import { useSelector } from 'react-redux';
import { useParams, useLocation } from 'react-router-dom';
import { apAppOriginSelector, payAppOriginSelector } from '@/domain/env';
import { getAppSwitchRedirectPath, isPayModulePath } from '@/components/mui/Layouts/components/ApplicationDropdown/hooks/getAppSwitchRedirectPath';

const useRedirectBetweenApps = () => {
  const { companyId } = useParams();
  const location = useLocation();
  const path = location.pathname;
  const payAppOrigin = useSelector(payAppOriginSelector);
  const apAppOrigin = useSelector(apAppOriginSelector);

  const isPayModule = isPayModulePath(path);

  const redirectBetweenApps = () => {
    const newPath = getAppSwitchRedirectPath(path, companyId);
    if (!newPath) return;

    const targetOrigin = isPayModule ? apAppOrigin : payAppOrigin;

    window.open(targetOrigin ? `${targetOrigin}${newPath}` : newPath, '_blank', 'noopener,noreferrer');
  };

  return { redirectBetweenApps, isPayModule };
};

export default useRedirectBetweenApps;
